import type { WebStatus } from "@shared/services/pim/types";
import type { TFunction } from "i18next";

/** Every PIM web status, in the order the status filter lists them. */
export const ADMIN_WEB_STATUSES: readonly WebStatus[] = [
  "Visible for Sale",
  "Visible but not for Sale",
  "Not Visible",
  "Out of Stock",
  "Temporarily Out of Stock",
];

// Same palette as the roaster-facing Status cell (StatusCellMarkup); the two
// statuses that table folds into "Out of Stock" keep their own shade here.
export const WEB_STATUS_BADGE_CLASSES: Record<WebStatus, string> = {
  "Visible for Sale": "bg-green-500/10 text-green-700 dark:text-green-400",
  "Not Visible": "bg-gray-500/10 text-gray-700 dark:text-gray-400",
  "Out of Stock": "bg-amber-500/10 text-amber-700 dark:text-amber-400",
  "Temporarily Out of Stock": "bg-orange-500/10 text-orange-700 dark:text-orange-400",
  "Visible but not for Sale": "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400",
};

// Unlike the roaster-facing products table, the admin catalogue keeps every
// PIM status distinct so a manager can tell them apart.
const WEB_STATUS_LABEL_KEYS: Record<WebStatus, string> = {
  "Visible for Sale": "views.productsTable.status.published",
  "Not Visible": "views.productsTable.status.notVisible",
  "Out of Stock": "views.productsTable.status.outOfStock",
  "Temporarily Out of Stock": "admin.productCatalogue.status.temporarilyOutOfStock",
  "Visible but not for Sale": "admin.productCatalogue.status.visibleNotForSale",
};

export const webStatusLabel = (t: TFunction, status: WebStatus): string => {
  const label: unknown = t(WEB_STATUS_LABEL_KEYS[status]);
  return typeof label === "string" ? label : status;
};
